<template>
  <div class="tes-employees-actions">
    <div class="listing-title">{{ $t(titleAllOrFiltered) }}</div>

    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/tes-employees/list?activeInactive=${activeInactive}&sortBy=${sortBy}
              &sortDirection=${sortDirection}&recordsPerPage=${recordsPerPage}&offset=${offSet}`,
          searchKeys: ['searchParam']
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
        @search-in-progress="onSearchInProgress($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="export">
      <router-link to="/tes-employees/create">
        <TolAltButton icon-name="plus" label="New Tes Employee" />
      </router-link>
      <TolAltButton
        v-click-outside="() => (showSettingsDropdown = false)"
        icon-name="file-excel"
        label="Export to Excel"
        @click="toggleDropdown"
      />

      <Dropdown
        v-show="showSettingsDropdown"
        :menu-items="[{ label: 'Export All' }, { label: 'Export this page' }]"
        class="dropdown-menu-right"
        @optionClicked="onExportChange($event)"
      />
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import {
  TesEmployeesListingActions,
  TesEmployeesListingGetters
} from '@/app/features/tes-employees/features/tes-employees-listing/tes-employees-listing.keys';
import vClickOutside from 'v-click-outside';
import Dropdown from '@/app/components/Dropdown';
import TolTypeAhead from '@/app/components/TolTypeAhead';

export default {
  name: 'TesEmployeesActions',
  components: {
    Dropdown,
    TolAltButton,
    TolTypeAhead
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    titleAllOrFiltered: {
      type: String,
      default: 'tesEmployees.listing.actions.titleAll'
    }
  },

  data() {
    return {
      showSettingsDropdown: false
    };
  },
  computed: {
    activeInactive() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesActiveInactive];
    },
    sortBy() {
      return this.$store.getters[TesEmployeesListingGetters.SortBy];
    },
    sortDirection() {
      return this.$store.getters[TesEmployeesListingGetters.SortDirection];
    },
    recordsPerPage() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesPerPage];
    },
    offSet() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesListingOffset];
    }
  },

  methods: {
    onExportChange(event) {
      if (event.menuOption === 'Export All') {
        this.$store.dispatch(TesEmployeesListingActions.ExportAllTesEmployeesAsExcel);
      } else {
        this.$store.dispatch(TesEmployeesListingActions.ExportCurrentPageTesEmployeesAsExcel);
      }
    },
    toggleDropdown() {
      this.showSettingsDropdown = !this.showSettingsDropdown;
    },
    onFiltered(results) {
      results.data.map(tesEmployee => {
        tesEmployee.tesEmployeeName = tesEmployee.last_name + ', ' + tesEmployee.first_name;
      });
      this.$store.dispatch(TesEmployeesListingActions.UpdateSearchList, results);
    },
    onSearchInProgress(searchFlag) {
      this.$emit('load-spinner', searchFlag);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.tes-employees-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
  align-items: center;
  .search-container {
    margin-right: 3px;
  }

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }

  .export {
    display: flex;
    position: relative;
    justify-content: flex-end;
    flex-basis: 25%;
    a {
      text-decoration: none;
      color: inherit;
    }

    .wrapper {
      margin-right: 3px;
    }
  }

  .search {
    margin-left: auto;
    flex-basis: 50%;
  }
}
</style>
